import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';

type GetShowOvernightFilterProps = {
  localization: Localization;
  transport: ProductsData['transport'];
  searchParams: SearchParams;
};

export const getShowOvernightFilter = ({
  localization,
  transport,
  searchParams,
}: GetShowOvernightFilterProps): boolean => {
  const overnightFlightsEnabled = !!localization?.configValuesApp?.overnightFlightsEnabled;
  const overnightAvailable = !!transport?.overnightAvailable;
  const overnightSelected = searchParams[URLParameters.OVERNIGHT_FLIGHTS] === '1';

  return overnightFlightsEnabled && (overnightAvailable || overnightSelected);
};
